import * as React from 'react';
import { TbChartArea, TbChartAreaFilled } from 'react-icons/tb';
import { VscGraphLine } from "react-icons/vsc";
import { TiChartArea } from "react-icons/ti";
import { FaBug } from "react-icons/fa";

export function TbChartAreaIcon(props) {
    return <TbChartArea {...props} />;
}

export function TbChartAreaFilledIcon(props) {
    return <TbChartAreaFilled {...props} />;
}

export function VscGraphLineIcon(props) {
    return <VscGraphLine {...props} />;
}

export function TiChartAreaIcon(props) {
    const viewBox = "0 3 24 24";
    return <TiChartArea {...props} viewBox={viewBox} />;
}

export function FaBugIcon(props) {
    return <FaBug {...props} />;
}